<template>
  <div class="mate-stic">
      <div class="mate-head">
          <div style="width:50%;text-align: left;">
              <el-page-header @back="goBack" :content="unitName+'  (岗位管理)'" style="margin-right:1vw;"></el-page-header>
             
              <!-- <span style="margin-left:1vw;">采购类型：</span>
              <el-select v-model="search.purchaseType" clearable placeholder="请选择">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
              </el-select>
              <span style="margin-left:1vw;">日期：</span>
              <el-date-picker v-model="search.createDate" type="date" value-format="yyyy-MM-dd" clearable placeholder="选择日期"></el-date-picker> -->
          </div>
          <div style="display:flex;width: 50%;justify-content: space-around;align-items: center;">  
              <span>岗位名称：</span>
              <el-input placeholder="请输入岗位名称" v-model="search.postName" clearable></el-input>
              <el-button type="primary" style="margin-left:1vw;" @click="doFilter">查询</el-button>
              <el-button type="success" @click="addFun">添加</el-button>
              <!-- <el-upload
                class="upload-demo"
                ref="upload"
                :action="uploadUrl"
                :headers="uploadHead"
                :data="uploadData"
                :on-success="handleAvatarSuccess"
                :show-file-list="false">
                <el-button type="primary">产品清单导入</el-button>
              </el-upload>
              <el-dropdown split-button type="primary" @command="handleCommand">
                  <span class="el-dropdown-link" style="cursor: pointer;">
                      导出
                  </span>
                  <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click="exportData" command="1">导出数据</el-dropdown-item>
                      <el-dropdown-item @click="exportFun" command="2">导出模板</el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown> -->
          </div>
      </div>
      <div class="mate-main">
          <el-table
            stripe
            :data="listData"
            border
            style="width: 100%; height: 100%;"
            
            :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
          >
              <template slot="empty">
                  <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100" >
                  <template slot-scope="scope">
                      <a>{{ scope.$index+1 }}</a>
                  </template>
              </el-table-column>
              <el-table-column label="岗位名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.postName }}</span>
                </template>
              </el-table-column>       
              <el-table-column label="创建人">
                <template slot-scope="scope">
                  <span>{{ scope.row.createBy }}</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" prop="createDate">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column> 
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
          >
          </el-pagination>
      </div>
      <!-- 新增窗口 -->
      <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="500px"
      >
      <el-form :model="addForm" ref="addForm" :rules="rules" label-width="160px" :label-position="labelPosition">
      
          <el-form-item label="岗位名称："  prop="postName">
            <el-input v-model="addForm.postName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
      </div>
      </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
  data(){
    var checkprice = (rule, value, callback) => {
            if (value == '') {
                callback(new Error('请输入单价'))
            } else if (!this.isPrice(value)) {
                //引入methods中封装的检查手机格式的方法
                callback(new Error('请输入正确的单价!'))
            } else {
                callback()
            }
        }
      return{
          groupId:'',
          unitId:'',//申请id
          search:{
            productName:''
          
          },
          listData:[],
          dataText:'数据加载中...',
          currentPage:1,
          pageSize:10,
          totalItems:0,
          //弹出框
          addFormVisible:false,
          addForm:{
            postId:'',          
            postName:''
          },
          dialogTitle:'',
          rules:{
              productCode:[{required: true, message: '请输入产品编码', trigger: 'blur'}],
              productName:[{required: true, message: '请输入产品名称', trigger: 'blur'}],
              productSpecs:[{required: true, message: '请输入产品规格', trigger: 'change'}],
              productPrice:[{required: true, validator: checkprice, trigger: 'change'}],
          },
          labelPosition:'right',
          supList:[],//发票类型
          unitName:'',//页面单号
          //导入
          uploadUrl:myHttp.importModelProduct,
          uploadHead:{
              accessToken: util.session.get('token')
          },
          uploadData:{
              // companyId:'',
              unitId:''
          },

      }
  },
  mounted(){
      this.groupId = util.session.get('companyId')
      var param = this.$route.params
      this.unitId = param.unitId
      this.unitName = param.unitName
      // this.uploadData.companyId = this.groupId
      this.uploadData.unitId = this.unitId
      this.addForm.unitId = this.unitId
      // this.getPiaoType()
      this.getData()
  },
  methods:{
      handleSizeChange(val) {
          this.pageSize = val
          this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
          this.currentPage = val
          this.getData()
      },
      // 监控当前页码
      currentChangePage() {
          this.getData()
      },
      //查询
      doFilter(){
          this.currentPage = 1
          this.getData()
      },
      //获取数据
      getData(){
          var that = this
          this.search.unitId = this.unitId
          this.search.pageSize = this.pageSize
          this.search.pageNum = this.currentPage
          myHttp.findSysPostListPage(this.search).then(function(resp){
              if(resp.data.code=='200'){
                  var list = resp.data.data.list||[]
                  that.listData = list
                  that.totalItems = resp.data.data.total

                  if(list.length==0){
                      that.dataText = '暂无数据'
                  }
              }else{
                  that.dataText = '暂无数据'
              }
          })
      },

      //获取采购类型
      getPiaoType(){
          var that = this
          myHttp.findCompanySupplierList({
              companyId:this.groupId,
              pageSize:10000,
              pageNum:1
          }).then(function(resp){
              if(resp.data.code=='200'){
                  var list = resp.data.data.list||[]
                  that.supList = list
              }
          })
      },
      //获取名称
      getNameByType(id){
          var list = this.supList
          var result = ''
          for(var i=0;i<list.length;i++){
              if(id==list[i].unitId){
                  result = list[i].supplierName
              }
          }
          return result
      },

      //添加
      addFun(){
          this.addFormVisible = true
          this.dialogTitle = '添加'
          this.addForm.unitId=this.unitId
          // this.addForm.companyId = this.groupId
          this.addForm.postId = ''
          this.addForm.postName = ''
       
      },
    
      //编辑
      handleEdit(index,row){
          this.addFormVisible = true
          this.dialogTitle = '修改'
          this.addForm.unitId=this.unitId
          this.addForm.postId = row.postId
          this.addForm.postName =  row.postName 
      },
      //提交
      sumbitAddRow(formName){
          var that = this          
          this.$refs[formName].validate((valid) => {
              if (valid) {
                  if(that.addForm.postId==""){
                      myHttp.addSysPost(this.addForm).then(function(resp){
                      if(resp.data.code=="200"){
                          that.$message.success("添加成功");
                          that.addFormVisible = false;
                          that.currentPage = 1;
                          that.getData();
                      }else{
                          that.$message.error(resp.data.msg);
                      }
                      },function(){});
                  }else{
                      myHttp.editSysPost(this.addForm).then(function(resp){
                      if(resp.data.code=="200"){
                          that.$message.success("修改成功");
                          that.addFormVisible = false;
                          that.getData();
                      }else{
                          that.$message.error(resp.data.msg);
                      }
                      },function(){});
                  }
              }
          });
      },
      //删除
      handleDelete(index,row){
          var that = this;
          this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              myHttp.deleteSysPost({
                postId:row.postId
              }).then(function(resp){
                  if(resp.data.code=="200"){
                      that.$message({
                          type: 'success',
                          message: '删除成功!'
                      })
                      that.getData();
                  }else{
                      that.$message.error(resp.data.msg);
                  }
              },function(){});
           }).catch(err => {          
          })
      },
      //生成编号
      goBack(){
          this.$router.go(-1)
      },
      //导出模板
      exportFun(){
          window.open(myHttp.downloadModelProduct+'?unitId='+this.unitId+'&accessToken='+util.session.get('token'))
      },
      //导入
      handleAvatarSuccess(res,file){
          if(res.code=='200'){
              this.$message.success('导入成功')
              this.getData()
          }else{
              this.$message.error(res.msg)
          }
      },
      //导出数据
      exportData(){
          window.open(myHttp.exportCompanySupplierProduct+'?unitId='+this.unitId+'&accessToken='+util.session.get('token'))
      },
      //点击导出
      handleCommand(command){
          if(command=='1'){
              this.exportData()
          }else if(command=='2'){
              this.exportFun()
          }
      },
      isPrice(val) {
            if (!/^([0-9]\d*(\.\d+)?|0)$/.test(val)) {
                return false
            } else {
                return true
            }
        },
      
  }
}
</script>

<style scoped>
  .mate-stic{
      width: 100%;
      height: 100%;
      position: relative;
      padding: 1vh;
      overflow: auto;
  }
  .title-crumb{
      width: 100%;
      height: 4vh;
      position: relative;
      display: flex;
      align-content: center;
      align-items: center;
      padding-left: 1vw;
  }
  .mate-head{
      width: 100%;
      height: 8vh;
      position: relative;
      background: #fff;
      padding: 2vh 1vw 1vh;
      display: flex;
      /* justify-content: flex-start;
      justify-items: flex-start; */
      justify-content: space-between;
      align-content: center;
      align-items: center;
      border-bottom: 5px solid #ecf0f5;
  }
  /* .mate-head-left{
      width: 7vw;
      position: relative;
      text-align: right;
      padding: 1vh 0;
  }
  .mate-head-r{
      width: calc( 100% - 10vw );
      position: relative;
      height: 5vh;
      overflow: hidden;
  }
  .mate-head-r.showAll{
      height: auto;
  }
  .mate-head-r-item{
      width: auto;
      position: relative;
      margin-right: 2vh;
      display: flex;
      align-items: center;
      float: left;
      margin-bottom: 1vh;
      cursor: pointer;
      color: #3E50B4;
      padding: 1vh 1vw;
      border-radius: 5px;
  }
  .mate-head-r-item:hover{
      background: #0490F9;
      color: #fff;
  }
  .mate-head-r-item.cur{
      background: #0490F9;
      color: #fff;
  }
  .mate-head-bottom{
      width: 3vw;
      display: flex;
      justify-items: flex-end;
      align-items: flex-end;
      min-height: 5vh;
      padding-bottom: 1vh;
      cursor: pointer;
  } */

  .mate-main{
      width: 100%;
      height: calc( 100% - 14vh );
      position: relative;
  }
</style>

<style>

</style>